import { render, staticRenderFns } from "./DepartmentDimensions.vue?vue&type=template&id=6d61ca9b&scoped=true"
import script from "./DepartmentDimensions.vue?vue&type=script&lang=js"
export * from "./DepartmentDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61ca9b",
  null
  
)

export default component.exports